import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { ContactFormWidget } from './ContactFormWidget'

class HoldstyringContactFormElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return ContactFormWidget
  }

  // Supported HTML attributes:
  //   title="..."          — heading inside the card (default: "Kontakt os")
  //   subtitle="..."       — sub-text under heading (default: standard Danish copy)
  //   show-phone="false"   — hide phone field (default: visible)
  protected getWidgetProps() {
    return {
      title: this.getAttribute('title') || null,
      subtitle: this.getAttribute('subtitle') || null,
      showPhone: this.getAttribute('show-phone') !== 'false',
    }
  }
}

if (!customElements.get('holdstyring-contact-form')) {
  customElements.define('holdstyring-contact-form', HoldstyringContactFormElement)
}

export { HoldstyringContactFormElement }
